import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { SharedService } from '../services/shared/shared.service';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const sharedService = inject(SharedService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated using the auth service
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    return true;
  }

  // Redirect to login with return URL
  router.navigate(['/auth/login']);
  // , {
  //     queryParams: { returnUrl: state.url },
  //   }
  return false;

  // if (sharedService.token) {
  //   return true;
  // } else {
  //   router.navigate(['/landing']);
  //   return false;
  // }
};
